import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JourneysService } from './../../journeys.service';
import { JourneyDetail } from './../../../../models/journey/journey-detail';
import { PermissionsService } from '../../../../shared/services/permissions.service';

@Component({
  selector: 'app-edit-journey-details',
  templateUrl: './edit-journey-details.component.html',
  styleUrls: ['./edit-journey-details.component.less'],
  providers: [JourneysService]
})

export class EditJourneyDetailsComponent implements OnInit {
  @Input() journey?: JourneyDetail;
  @Input() saving?: boolean;
  @Output() update: EventEmitter<JourneyDetail> = new EventEmitter<JourneyDetail>();
  public content: FormGroup;
  public simplifiedJourneyManagement: boolean;

  constructor(
    private _fb: FormBuilder,
    private permissionsService: PermissionsService,
  ) { }

  ngOnInit(): void {
    if (!this.journey) {
      this.journey = new JourneyDetail;
      this.journey.name = '';
      this.journey.description = '';
      this.journey.image = '';
      this.journey.duration = null;
      this.journey.credit_hours = null;
      this.journey.browseable = false;
      this.journey.media_video_id = null;
      this.journey.show_certificate = false;
    }
    this.content = this._fb.group({
      name: [this.journey.name, <any>Validators.required],
      description: [this.journey.description, <any>Validators.required],
      duration:[this.journey.duration],
      credit_hours: [this.journey.credit_hours],
      browseable: [this.journey.browseable],
      media: [this.journey.media_video_url || this.journey.image],
      show_certificate: [this.journey.show_certificate],
    });
    this.simplifiedJourneyManagement = this.permissionsService.simplifiedJourneyManagement;
  }

  public saveJourneyEdits(): void {
    let updatedJourney = JSON.parse(JSON.stringify(this.journey));
    for (let key in this.content.controls) {
      if (key === 'media') {
        const media = this.content.controls[key].value;
        this.updateMedia(updatedJourney, media);
      } else if (key in updatedJourney) {
        updatedJourney[key] = this.content.controls[key].value;
      }
    }
    this.update.emit(updatedJourney);
  }

  private updateMedia(updatedJourney: JourneyDetail, media: any): void {
    if (media == null || media === '') {
      updatedJourney.image = null;
      updatedJourney.media_video_id = null;
      return;
    }
    // If we already have an image/video, keep it.
    if (typeof media === 'string') {
      return;
    }
    updatedJourney.image = null;
    updatedJourney.media_video_id = null;
    if (media.videoId) {
      updatedJourney.media_video_id = media.videoId;
    } else if (media.key) {
      updatedJourney.image = media.key;
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/journeys/journey/edit-journey-details/edit-journey-details.component.ts